import { CSSObject } from '@emotion/react'
import { useState, useEffect, useRef } from 'react'
import { AssetReference } from '@opallabs/cassini'
import { Asset } from '@opallabs/kuiper'
import { baseStyles } from '../../styles'
import { Overlay } from './Overlay'
import { getAssetStyles, getAssetBaseStyles } from './styles'

export type DisplayProps = {
  accountImage?: AssetReference
  accountName: string
  accountUsername: string
  asset?: AssetReference
  collabAccount?: string
  content: string
  contentCharacterLimit: number
  contentPlaceholderText: string
  effect: string
  instagramCollab?: boolean
  isPresenting: boolean
  musicTitle: string
  onContentChange: (value: string) => void
  onExpandAsset: (id?: number) => void
  onMusicChange: (value: string) => void
  onRemoveAsset: (id?: number) => void
  postType: string
  readOnly: boolean
  truncate: boolean
  updateCoverAsset: (val: string, id?: number) => void
}

const defaultFooterHeight = 137

export const MobileSingle: React.FC<DisplayProps> = ({
  accountImage,
  accountName,
  accountUsername,
  asset,
  collabAccount,
  content,
  contentCharacterLimit,
  contentPlaceholderText,
  effect,
  instagramCollab,
  isPresenting,
  musicTitle,
  onContentChange,
  onExpandAsset,
  onMusicChange,
  onRemoveAsset,
  readOnly,
  truncate,
  updateCoverAsset,
}) => {
  const [isHovered, setIsHovered] = useState(false)
  const footerRef = useRef<HTMLDivElement>(null)
  const containerRef = useRef<HTMLDivElement>(null)
  const [assetBaseStyles, setAssetBaseStyles] = useState<CSSObject>(
    getAssetBaseStyles(false, defaultFooterHeight, truncate)
  )
  useEffect(() => {
    if (footerRef.current && containerRef.current) {
      setAssetBaseStyles(
        getAssetBaseStyles(false, footerRef.current.offsetHeight, truncate)
      )
    }
  }, [content, footerRef.current?.offsetHeight, truncate])

  return (
    <div
      css={baseStyles('mobileSingle', Boolean(asset))}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Overlay
        accountImage={accountImage}
        accountName={accountName}
        accountUsername={accountUsername}
        collabAccount={collabAccount}
        content={content}
        contentCharacterLimit={contentCharacterLimit}
        contentPlaceholderText={contentPlaceholderText}
        effect={effect}
        footerRef={footerRef}
        instagramCollab={instagramCollab}
        musicTitle={musicTitle}
        onContentChange={onContentChange}
        onMusicChange={onMusicChange}
        readOnly={readOnly}
        setIsHovered={setIsHovered}
        truncate={truncate}
      />
      {asset && (
        <div ref={containerRef} css={assetBaseStyles}>
          <Asset
            assetReference={asset}
            hasAssetOptions={true}
            preview={false}
            isHovered={isHovered}
            overrideStyles={{
              asset: getAssetStyles(),
              assetBase: getAssetStyles(),
            }}
            disableMediaControls={false}
            hasAssetOverlay={asset && (!readOnly || isPresenting)}
            updateCoverAsset={(val: string) => updateCoverAsset(val, asset.id)}
            onEmbiggen={() => onExpandAsset(asset.id)}
            onRemove={() => onRemoveAsset(asset.id)}
          />
        </div>
      )}
    </div>
  )
}
